import React, { useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter as Router} from "react-router-dom"
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Video from "./Video/Video";
import Exam from "./Exam/Exam";
import Landing from "./Landing/Landing";
import Course from "./Course/Course";
import Login from "./Login/Login";
import MyCourse from './MyCourse/MyCourse';
import Logout from './Logout/Logout';
import Cookies from "js-cookie";


const RoutesFile = () => {
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [token, setToken] = useState(Cookies.get("token") || null);

    // Check for token changes
    useEffect(() => {
      const checkToken = () => {
        const newToken = Cookies.get("token");
        if (newToken !== token) {
          setToken(newToken);
        }
      };
  
      document.addEventListener("tokenChange", checkToken);
      return () => document.removeEventListener("tokenChange", checkToken);
    }, [token]);

    return (
      <Router>
        <Header setIsLoginOpen={setIsLoginOpen} token={token} setToken={setToken} />
        <Login isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} setToken={setToken}/>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route exact path="/course" element={<Course />} />
            <Route path="/video" element={<Video />} />
            <Route path="/exam" element={<Exam setIsLoginOpen={setIsLoginOpen} />} /> 
            <Route path="/mycourse" element={<MyCourse/>}/>
          </Routes>
        <Footer />
      </Router>
    )
}

export default RoutesFile;